import { render } from "./componentsMaterial.vue?vue&type=template&id=3748b5f2&scoped=true&ts=true"
import script from "./componentsMaterial.vue?vue&type=script&lang=ts"
export * from "./componentsMaterial.vue?vue&type=script&lang=ts"

import "./componentsMaterial.vue?vue&type=style&index=0&id=3748b5f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3748b5f2"]])

export default __exports__